import { useState, useEffect } from 'react';
import { JOKI } from '../../JOKI';
import { AUTH_STATUS } from './AuthenticationService';

export function useAuthenticationStatus() {
    const [status, setStatus] = useState(() => {
        const statusNow = JOKI.ask({
            to: 'AuthenticationService',
            key: 'getStatus',
            syncAsk: true,
        });
        return statusNow.AuthenticationService;
    });

    useEffect(() => {
        return JOKI.on({
            from: 'AuthenticationService',
            key: 'AuthenticationStatusChanged',
            fn: event => {
                if (event.from === 'AuthenticationService' && event.key === 'AuthenticationStatusChanged') {
                    // console.log(`React:Hook:UseAuthenticationStatus: Status changed from ${status} to ${event.body}`);
                    setStatus(event.body);
                }
            },
        });
    });

    useEffect(() => {
        return JOKI.on({
            from: 'AuthenticationService',
            key: 'sessionHasDied',
            fn: event => {
                if (event.broadcast === true) {
                    setStatus(AUTH_STATUS.error);
                }
            },
        });
    });

    function renewAuthentication() {
        JOKI.trigger({
            to: 'AuthenticationService',
            key: 'renew',
            from: 'AuthenticatioRenewer',
        });
    }

    return [status, renewAuthentication];
}

export function renewAuthentication() {
    JOKI.trigger({
        to: 'AuthenticationService',
        key: 'renew',
        from: 'AuthenticatioRenewer',
    });
}
